<template>
    <div>       
        <div class="tab-title">安全设置</div>
        <div class="sefety-container">
            <div class="sefety-item-title new-password">更改密码</div>
            <div class="sefety-item-content">
                <el-form :model="passwordForm" :rules="pswFormRules" ref="passwordForm" label-width="120px" class="user-password-form">
                    <el-form-item label="输入旧密码" prop="oldPassword" class="profile-form-item">
                        <div class="sefety-item-input">
                            <el-input show-password v-model="passwordForm.oldPassword" placeholder="输入旧密码"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="设置新密码" prop="password" class="profile-form-item">
                        <div class="sefety-item-input">
                            <el-input show-password v-model="passwordForm.password" placeholder="6-20位字符（最好不是纯数字）"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="确 认 密 码" prop="notpassword" class="profile-form-item">
                        <div class="sefety-item-input">
                            <el-input show-password v-model="passwordForm.notpassword" placeholder="再次输入新密码"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="confirmed-save-btn" @click="submitForm('passwordForm')">确定</el-button>
                        <el-button class="confirmed-save-btn" @click="resetForm('passwordForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="sefety-item-title new-mobile">更改手机</div>
            <div class="sefety-item-content">
                <el-form :model="mobileForm" :rules="mobFormRules" ref="mobileForm" label-width="120px" class="user-password-form">
                    <el-form-item label="原 手 机 号" class="profile-form-item">
                        <div class="sefety-item-input">
                            <div class="mobile-container">{{ initUserMobile }}</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="完整手机号" prop="oldMobile" class="profile-form-item">
                        <div class="sefety-item-input">
                            <el-input v-model="mobileForm.oldMobile" placeholder="输入原手机号"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="新 手 机 号" prop="mobile" class="profile-form-item">
                        <div class="sefety-item-input">
                            <el-input ref="newMobile" v-model="mobileForm.mobile" placeholder="输入新手机号"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="短信验证码" prop="code" class="profile-form-item">
                        <div class="sefety-item-input flex">
                            <el-input v-model="mobileForm.code" placeholder="输入验证码"></el-input>
                            <el-button :disabled="banGetCode" class="get-code-btn" @click="getCode()">{{ getCodeText }}</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="confirmed-save-btn" @click="submitForm('mobileForm')">确定</el-button>
                        <el-button class="confirmed-save-btn" @click="resetForm('mobileForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { apiMap } from '../../utils/apiMap';
export default {
    name: "user-sefety",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.passwordForm.password) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        var validateOldMobile = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入原手机号'));
            } else if (value !== this.user.mobile) {
                callback(new Error('原手机号不正确'));
            } else {
                callback();
            }
        };
        var validateNewMobile = (rule, value, callback) => {
            var mobileRegExp = /^1[345789]\d{9}$/;
            if (value === '') {
                callback(new Error('请输入新手机号'));
            } else if (!mobileRegExp.test(value)) {
                callback(new Error('手机号格式不正确'));
            } else {
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            var numberRegExp = /^[0-9]+$/;
            if (value === '') {
                callback(new Error('请输入验证码'));
            } else if (!numberRegExp.test(value)) {
                callback(new Error('请输入数字验证码'));
            } else {
                callback();
            }
        };
        return {
            passwordForm: {
                oldPassword: '',
                password: '',
                notpassword: '',
            },
            pswFormRules: {
                oldPassword: [
                    { required: true, message: '请输入旧密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                notpassword: [
                    { validator: validatePass,trigger: 'blur' }
                ],
            },
            mobileForm: {
                oldMobile: '',
                mobile: '',
                code: '',
            },
            mobFormRules: {
                oldMobile: [
                    { validator: validateOldMobile,trigger: 'blur' }
                ],
                mobile: [
                    { validator: validateNewMobile,trigger: 'blur' }
                ],
                code: [
                    { validator: validateCode,trigger: 'blur' }
                ],
            },
            getCodeText: "发送短信",
            banGetCode: false,
            timer: null,
        }
    },
    computed: {
        ...mapGetters([
            'user',
        ]),
        initUserMobile() {
            return `${this.user.mobile.slice(0,3)}********`
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) { 
                    let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));          
                    switch (formName) {
                        case 'passwordForm':
                            var filedArray = [
                                'oldPassword',
                                'password',
                                'notpassword'
                            ];
                            var submitArry = [];
                            submitArry.push(`token=${loginUser.token}`);
                            for (let index = 0; index < filedArray.length; index++) {
                                const element = filedArray[index];
                                var filedValue = this.passwordForm[element];
                                if (filedValue) {
                                    submitArry.push(`${element}=${filedValue}`);
                                }
                            }                      
                            this.setNewPassword(submitArry);
                            break;
                        case 'mobileForm':
                            let submitData = `token=${loginUser.token}&mobile=${this.mobileForm.mobile}&code=${this.mobileForm.code}`
                            this.changeMobile(submitData);
                            break;
                    }
                   
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        getCode(){
            let _this = this;
            _this.$refs['mobileForm'].validateField('mobile',(error) => {
                if (!error) {
                    let newMobile = _this.$refs.newMobile.value;
                    if (newMobile) {
                        _this.sendCode(function (respond) {
                            if (respond.statusCode==1) {
                                _this.$notify({
                                    title: '提示',
                                    message: '验证码发送成功',
                                    type: 'success'
                                });
                                _this.countSecondDown();
                            } else {
                                _this.$alert(respond.data, {
                                    confirmButtonText: '确定',
                                    showClose: false
                                });
                            }
                        });
                    }                  
                }
            });
        },
        sendCode(okCBK) {
            let _this = this;
            _this.$axios({
                baseURL: apiMap['commonUrl'],
                method: apiMap['verifyCode']['method'],
                url: apiMap['verifyCode']['url'],  
                data: `mobile=${this.$refs.newMobile.value}&scene=1`,
            }).then(function (response) {
                okCBK(response.data.result);
            });       
        },
        countSecondDown() {
            const TIME_COUNT = 59;
            if (!this.timer) {
                var count = TIME_COUNT;
                this.banGetCode = true;
                this.timer = setInterval(() => {
                    if (count > 0 && count <= TIME_COUNT) {
                        this.getCodeText = `发送短信(${count--})`;
                    } else {
                        clearInterval(this.timer);
                        this.timer = null;
                        this.banGetCode = false;
                        this.getCodeText = "发送短信";
                    }
                }, 1000)
            }
        },
        setNewPassword(paramArr) {
            let _this = this;
            _this.$axios({
                baseURL: apiMap['commonUrl'],
                method: apiMap['setNewPassword']['method'],
                url: apiMap['setNewPassword']['url'],  
                data: paramArr.join("&"),
            }).then(function (response) {
                if (response.data.result.statusCode == 1) {
                    _this.$alert('更改密码成功，请重新登录', {
                        confirmButtonText: '确定',
                        showClose: false,
                        callback: action => {
                            _this.goToLogin();
                        }
                    });
                }else {
                    _this.$alert(response.data.result.data, {
                        confirmButtonText: '确定',
                        showClose: false,
                    });
                }
            });
        },
        changeMobile(params) {
            let _this = this;
            _this.$axios({
                baseURL: apiMap['commonUrl'],
                method: apiMap['verifyCode']['method'],
                url: apiMap['verifyCode']['url'],  
                data: params,
            }).then(function (response) {
                // console.log(response.data);
                if (response.data.result.statusCode == 1) {
                    _this.$alert('更改手机号成功，请重新登录', {
                        confirmButtonText: '确定',
                        showClose: false,
                        callback: action => {
                            _this.goToLogin();
                        }
                    });
                }else {
                    _this.$alert(response.data.result.data, {
                        confirmButtonText: '确定',
                        showClose: false,
                    });
                }
            });
        },
        goToLogin(){
            tim.logout();
            let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));          
            this.$axios({
                baseURL: apiMap['commonUrl'],
                method: apiMap['logout']['method'],
                url: apiMap['logout']['url'],       
                data: `token=${loginUser.token}`,
            })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
            this.$store.dispatch("resetConversationList");
            sessionStorage.clear();
            localStorage.clear();
            this.$router.push("/login");     
        },
    }
}
</script>
<style scoped>
.tab-title {
    height: 40px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    letter-spacing: 2px;
    background-color: #1A70DB;
}

.sefety-item-title {
    height: 30px;
    padding-left: 40px;
    line-height: 30px;
    font-size: 15px;
    font-weight: bold;
    background-color: #DCECFF;
    background-repeat: no-repeat;
}

.new-password {
    background-image: url('../../assets/icon/user/cl_new_psw.png');
    background-position: 14px 7px;
}

.new-mobile {
    background-image: url('../../assets/icon/user/cl_new_phone.png');
    background-position: 12px 5px;
}

.sefety-item-content {
    background-color: #fff;
    padding: 10px 0 1px 7px;
}

.sefety-item-input {
    width: 400px;
}

.confirmed-save-btn {
    padding: 7px 10px;
}

.get-code-btn {
    margin-left: 10px;
}

.mobile-container {
    padding-left: 12px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
}
</style>